module.exports = __webpack_public_path__ + "static/media/topic03.7c0b368d.jpg";